export enum Application {
  SUBSCRIBER_TOOLTIP = 'Subscriber',
  CANNOT_SUBSCRIBE_OWN_SUBSCRIPTION = 'You cannot subscribe to your own subscription plan.',
  SCHEDULE = 'SCHEDULE',
  SEE_MORE_DIV = '<div class="content-length-handle hand-cursor" (click)="seeLessMore(val)"> See More </div>',
  SEE_LESS_DIV = '<div class="content-length-handle hand-cursor" (click)="seeLessMore(val)"> See Less </div>',
  IS_WHITE_LABEL = 'is_white_label',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  TYPE_GET = 'GET',
  TYPE_POST = 'POST',
  TYPE_PUT = 'PUT',
  TYPE_DELETE = 'DELETE',
  TYPE_PATCH = 'PATCH',
  LOGIN_DET = 'login-det',
  FM_USER = 'fm_user',
  ENCDATA = 'encData',
  EMAIL = 'email',
  PASSWORD = 'password',
  loginPath = '/auth',
  Content = '/content',
  BACKSPACE = 'Backspace',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  promotional = '/',
  home = 'home',
  dashboard = '/dashboard',
  authSignup = 'auth/signup',
  creatorUpgraded = 'creator-upgraded',
  verifyByOtp = 'verify-by-otp',
  userProfile = '/home/profile',
  makePayment = 'dashboard/make-payemnt',
  monitizeCourses = '/monetize/courses',
  dashboardDiscover = '/dashboard/posts/discover',
  creatorProfileInfo = '/edit-preference/become-a-creator/creator-profile-info',
  confirmCreator = '/edit-preference/become-a-creator/confirm-creator',
  contentCreator = '/edit-preference/become-a-creator/content-creator',
  verifyIdentity = '/edit-preference/become-a-creator/verify-identity',
  AddLesson = 'add-lesson',
  message = 'message',
  EXPERIENCE = 'experience',
  COURSE_CAPS = 'COURSE',
  EXPERIENCE_CAPS = 'EXPERIENCE',
  DOWNLOADABLE = 'downloadable',
  LIVESTREAM = 'LIVESTREAM',
  COURSE = 'course',
  COURSE_ENROLL = 'course enroll',
  VIP_OFFER = 'vip offer',
  MERCHANDISE = 'merchandise',
  MERCHANDISE_CAPS = 'MERCHANDISE',
  EVENT_CALENDAR = 'EVENT_CALENDAR',
  TICKET = 'ticket',
  TICKET_CAPS = 'TICKET',
  POST_UNLOCK = 'post unlock',
  GUEST_TIPPING = 'guest tipping',
  POST_TIP = 'post tip',
  CHAT_ROOM_TIP = 'chat room tip',
  POST_CAPS = 'POST',
  EARNING = 'Earning',
  VID_QUICKTIME = 'video/quicktime',
  VID_MP4 = 'video/mp4',
  MOBILE = 'mobile',
  Ios = 'Ios',
  IOS = 'iOS',
  IOS_SMALL = 'ios',
  NFT = 'nft',
  NFT_CAPS = 'NFT',
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  WEBP = 'webp',
  AVIF = 'avif',
  HEIF = 'heif',
  WEBM = 'webm',
  GIF = 'gif',
  IMAGE_GIF_TYPE = 'image/gif',
  MP3 = 'mp3',
  MP4 = 'mp4',
  WAV = 'wav',
  DOC = 'doc',
  DOCS = 'docs',
  CSV = 'csv',
  PPTX = 'pptx',
  EXCEL = 'excel',
  TXT = 'txt',
  PDF = 'pdf',
  HEIC = 'heif',
  MOV = 'mov',
  DIGIT = 'Digit',
  PROFILE = 'profile_',
  COMMENT = 'comment_',
  LIST_ICON = 'list_icon',
  BANNER = 'banner_',
  POST = 'post_',
  DISCOVERFEED = 'discover',
  FOLLOW = 'follow',
  SAVED = 'saved',
  COURSES = 'courses',
  MYPROFILE = 'myprofile',
  OTHERPROFILE = 'otherprofile',
  CREATOR = 'Creator',
  FAN = 'Fan',
  COLLABORATOR = 'Collaborators',
  SPAN = 'SPAN',
  HTTP = 'http',
  HTTP_COLAN = 'http://',
  A = 'A',
  TARGET = '_blank',
  BANNER_WIDTH = 800,
  BANNER_HEIGHT = 400,
  FOUR_HUNDRED_FOUR = 404,
  VIDEO_PREVIEW_WIDTH = 450,
  VIDEO_PREVIEW_HEIGHT = 200,
  IMAGE_PREVIEW_HEIGHT = 250,
  IMAGE_PREVIEW_WIDTH = 250,
  LARGE_IMAGE_PREVIEW_WIDTH = 400,
  LARGE_IMAGE_PREVIEW_HEIGHT = 400,
  DEFAULT_THEME_COLOR = 'linear-gradient(95deg, #1de9b6 0%, #00b6ea 100%)',
  DEFAULT_BUTTON_TEXT_COLOR = '#000000',
  DEFAULT_BG_COLOR = '#013956',
  DEFAULT_SECONDARY_BG_COLOR = '#002740',
  DEFAULT_TEXT_COLOR = '#ffffff',
  DEFAULT_PRESET_THEME_COLOR = '#09c6da',
  BLANK = '',
  experience = 'EXPERIENCE',
  REFRESH_TOKEN = 'fm_over',
  DEFAULT_LAT = '34.052235',
  DEFAULT_LONG = '-118.243683',
  THEME_DEFAULT = 'theme-default',
  THEME_LIGHT = 'theme-light',
  THEME_DARK = 'theme-dark',
  THEME_UNLOAD = 'theme_UNLOAD',
  POST_METHOD = 'POST',
  MY_COURSES = 'My Courses',
  Users = 'users',
  Follower = 'follower',
  Followers = 'followers',
  FollowerOnTopFans = 'follower on TopFan.com',
  FollowersOnTopFans = 'followers on TopFan.com',
  YourFollowers = 'your followers',
  Groups = 'groups',
  Broadcast = 'broadcast',
  Featured = 'featured',
  STR_ZERO = '0',
  ADD_LESSON = 'addLesson',
  THEME = 'theme',
  SUBSCRIPTION = 'subscription',
  SUBSCRIPTION_SALE = 'Subscription Sale',
  UNAUTHORIZED = 'Unauthorized',
  FEED = 'FEED',
  MESSAGE = 'message',
  MESSAGE_CAPS = 'Message',
  MESSAGE_CONTENT = 'Message Content',
  SET_UP_AUTOMATED_MESSAGE = 'SETUP AUTOMATED MESSAGES',
  MESSAGES = 'MESSAGES',
  MESSAGES_SMALL = 'Messages',
  FEATURED = 'Featured',
  GENERAL = 'General',
  BULK_SENT = 'Message Lists',
  SEARCH = 'Search',
  SEARCH_BY_REQUESTED_FROM = 'Search by Requested From',
  DOWNLOADABLES = 'downloadables',
  DOWNLOADABLES_LABEL = 'Downloadables',
  POST_FORUM = 'post forum',
  FORUM = 'FORUM',
  SEARCH_RESULT_PAGE = 'search-result',
  DASHBOARD = 'dashboard',
  FM_PRIMARY_USER = 'fm_primary_user',
  PRIORITY = 'Priority',
  VIDEO_COVER_ORIENTATION_MATCH_ERROR = 'Video and Cover Image Orientation must be same',
  SOMETHING_WENT_WRONG = 'Something went wrong. Please try again',
  REFUND_REJECTED = 'Refund Rejected',
  REFUND_DECLINED = 'Refund Declined',
  INSUFFICIENT_FUND = 'You cannot withdraw more than your current available balance. Please try again.',
  DELEGATE_PAYMENT_RESTRICTION_MSG = 'Delegates are not authorized to make payments. Please consult the creator to proceed with any purchases.',
  AUTH_EXPIRED = 'Your authentication has expired, please Sign In again.',
  ALL = 'ALL',
  ERROR_IP_ADDRESS = '0.0.0.0',
  CREATE_NEW_DM_MAILING_LIST = 'Create New Direct Message List',
  EDIT_MAILING_LIST = 'Edit Message List',
  MAILING_LIST_STEP_ONE = 'Step 1 of 2: Choose Recipients',
  MAILING_LIST_STEP_TWO = 'Step 2 of 2: Choose Message List Name and Icon',
  MAILING_LIST_INFO = 'This will be a list of your Fans that you can send multiple direct messages to via the messaging tab. After creating the Message List, you\'ll be taken to a screen where you can send your direct message.',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  SAVED_CREDIT_CARD = 'Saved Credit Card',
  ADMIN_OVERRIDE = 'ADMIN OVERRIDE',
  SHOPIFY = 'shopify',
  DESCRIPTION_MUST_NOT_CONTAIN_TRAILING_WHITESPACES = 'Description must not contain trailing whitespaces.',
  MESSAGE_SENT_SUCCESSFULLY_BUT_TIP_FAILED = 'Message sent successfully. However, Tip processing could not succeed. Tip Amount is refunded to your account.',
  FREE_DIRECT_MESSAGES_PER_MONTH = '[quantity] Free Direct Messages Per Month',
  UNLIMITED = 'Unlimited',
  REGULAR_PRICE_FOR_MESSAGE = 'Regular price to send a DM: [price]/msg',
  PAY_PER_MESSAGE_AND_TIP_MSG = 'You will be charged [priceForDm] for sending a direct message and [tipAmount] to send a Tip to [fullName].',
  onePointFive = 1.5,
  ZERO_POINT_FIVE = 0.5,
  ZERO_POINT_FOUR = 0.4,
  ZERO_POINT_THREE = 0.3,
  ZERO_POINT_TWO = 0.2,
  ZERO_POINT_TWO_FIVE = 0.25,
  EIGHT_POINT_TWO = 8.2,
  EIGHT_POINT_FOUR = 8.4,
  EIGHT_POINT_SIX = 8.6,
  EIGHT_POINT_EIGHT = 8.8,
  NINE_POINT_TWO = 9.2,
  NINE_POINT_FOUR = 9.4,
  NINE_POINT_SIX = 9.6,
  NINE_POINT_EIGHT = 9.8,
  TEN_POINT_FIVE = 10.5,
  ELEVEN_POINT_FIVE = 11.5,
  MINUS_ONE = -1,
  ZERO = 0,
  ZERO_POINT_ZERO_FIVE = 0.05,
  ONE = 1,
  ONE_POINT_SEVEN_FIVE = 1.75,
  ZERO_POINT_ZERO_ONE = 0.01,
  ZERO_POINT_SIX_FIVE = 0.65,
  ZERO_POINT_ZERO_ZERO_TWO_FIVE = 0.0025,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14,
  FIFTEEN = 15,
  SIXTEEN = 16,
  SEVENTEEN = 17,
  EIGHTEEN = 18,
  TWENTY = 20,
  TWENTY_ONE = 21,
  TWENTY_TWO = 22,
  TWENTY_THREE = 23,
  TWENTY_FOUR = 24,
  TWENTY_EIGHT = 28,
  TWENTY_FIVE = 25,
  TWENTY_SEVEN = 27,
  SEVEN_TWENTY = 720,
  TWELVE_EIGHTY = 1280,
  THIRTY = 30,
  THIRTY_ONE = 31,
  THIRTYONE = 31,
  THIRTY_TWO = 32,
  THIRTY_FIVE = 35,
  THIRTY_EIGHT = 38,
  THIRTY_NINE = 39,
  FOURTY = 40,
  FOURTY_TWO = 42,
  FOURTY_SIX = 46,
  FOURTY_EIGHT = 48,
  FOURTYEAIGHT = 48,
  ZERO_ASCII_CODE = 48,
  FIFTY = 50,
  FIFTY_ONE_FIVE = 51.5,
  FIFTY_THREE = 53,
  FIFTY_SEVEN = 57,
  FIFTYSEVEN = 57,
  FIFTY_NINE = 59,
  SIXTY = 60,
  SIXTY_FIVE = 65,
  SEVENTY = 70,
  EIGHTY = 80,
  NINETY = 90,
  NINETY_SIX = 96,
  ONE_HUNDRED = 100,
  ONE_HUNDRED_TEN = 110,
  ONE_HUNDRED_TWENTY = 120,
  ONE_HUNDRED_THIRTY = 130,
  ONE_HUNDRED_FORTY = 140,
  ONE_HUNDRED_EIGHTY = 180,
  ONE_HUNDRED_NINETY = 190,
  TWO_HUNDRED = 200,
  TWO_HUNDRED_ONE = 201,
  TWO_HUNDRED_TWENTY = 220,
  TWO_HUNDRED_FIFTY = 250,
  TWO_HUNDRED_SEVENTY_FIVE = 275,
  THREE_HUNDRED = 300,
  THREE_HUNDRED_TEN = 310,
  THREE_HUNDRED_ONE_FIVE = 315,
  THREE_HUNDRED_TWENTY = 320,
  FOUR_HUNDRED = 400,
  FOUR_HUNDRED_ONE = 401,
  FOUR_HUNDRED_THREE = 403,
  FOUR_HUNDRED_SIX = 406,
  FIVE_HUNDRED = 500,
  FIVE_HUNDRED_THREE = 503,
  SIX_HUNDRED_FIFTY = 650,
  FIVE_FIFTY = 550,
  FIVE_FIFTY_ONE = 551,
  SIX_HUNDRED = 600,
  SIX_EIGHT_ZERO = 680,
  SEVEN_SIXTY_SEVEN = 767,
  SEVEN_SIXTY_EIGHT = 768,
  SEVEN_HUNDRED = 700,
  EIGHT_HUNDRED = 800,
  NINE_HUNDRED = 900,
  NINE_NINTY_ONE = 991,
  NINE_NINTY_TWO = 992,
  NINE_HUNDRED_NINTY_NINE = 999,
  ONE_THOUSAND = 1000,
  ONE_THOUSAND_TWO_HUNDRED = 1200,
  ONE_THOUSAND_TWO_HUNDRED_ONE = 1201,
  ONE_THOUSAND_THREE_HUNDRED_FIFTY = 1350,
  THIRTEEN_HUNDRED_SIXTY_SIX = 1366,
  THIRTEEN_HUNDRED_SIXTY_SEVEN = 1367,
  FOURTEEN_HUNDRED_FORTY = 1440,
  INTERVAL_TWO_THOUSAND = 2000,
  SIXTEEN_HUNDRED = 1600,
  INTERVAL_THREE_THOUSAND = 3000,
  INTERVAL_FIVE_THOUSAND = 5000,
  FOUR_THOUSAND = 4000,
  FIVE_THOUSAND = 5000,
  TEN_THOUSAND = 10000,
  THIRTY_THOUSAND = 30000,
  TEN_MB_IN_BYTE = 10485760,
  ONE_THOUSAND_TWENTY_FOUR = 1024,
  FIVE_ONE_TWO = 512,
  BYTE_TO_MB = 1024000,
  ONE_TWO_SEVEN_FOUR_SIX_TWO = 127462,
  THUMBNAIL_QUALITY = 0.18,
  DEFAULT_QUALITY = 0.95,
  AUDIO_FILE_SIZE_LIMIT = 209715200,
  AUDIO_FILE_SIZE_LIMIT_5GB = 5368709120,
  IMAGE_FILE_SIZE_LIMIT = 10485760,
  VIDEO_FILE_SIZE_LIMIT = 536870912,  // 512MB
  MOVIE_FILE_SIZE_LIMIT = 5368709120, // 5GB
  TEN_GB_IN_BYTE = 10737418240, // 10GB
  REEL_FILE_SIZE_LIMIT = 209715200,
  POLL_IMAGE_FILE_SIZE_LIMIT = 52428800,
  selectAll = 'Select All',
  unSelectAll = 'UnSelect All',
  DATE_FORMAT = 'yyyy-MM-dd H:mm',
  MAKE_PAYMENT = '/dashboard/make-payment',
  MAKE_PAYMENT_AS_GUEST = '/dashboard/guest-make-payment',
  NAVIGATION_HISTORY = 'navigationHistory',
  POST_NOT_FOUND = 'This post is no longer available',
  RECRUITER_STORAGE_KEY = '/recruiter@',
  LAST_LOGIN_NAME = 'lastLoginEmail',
  SK = 'sk',
  CATEGORY_ID = 'category_id',
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
  GEO_LOCATION_NOT_SUPPORTED_MSG = 'Geolocation is not supported by this browser.',
  MY_EVENTS = 'Events',
  SEE_EVENTS = 'See Events',
  ONLY_SUBSCRIBER_CAN_DM_KEY = 'only_subcriber_can_DM',
  NINE_HUNDRED_NINETY_TWO = 992,
  FOUR_HUNDRED_FIFTY = 450,
  PASSED = 'past',
  LAST_SEO_PATH = 'last_seo_path',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  VERIFF_SDK = 'veriffSDK',
  VERIFY_YOUR_EMAIL = 'Verify your email',
  VERIFY_YOUR_TOPFANS_ACCOUNT = 'Verify Your TopFan Account',
  VERIFICATION_CODE_SENT = 'Verification Code has been sent to your email address.',
  TOPFAN_PUSH_NOTIFICATION = 'TopFan Push Notification',
  DEFAULT_TEXT = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages',
  UPLOADING = 'uploading',
  COMPLETED = 'completed',
  INITIATED = 'initiated',
  IMAGE_ACCEPT_TYPES = '.png, .jpg, .jpeg, .heic, .heif, .webp, .avif',
  IMAGE_ACCEPT_TYPES_INCLUDING_GIF = 'image/png, image/jpg, image/jpeg, image/gif, .heic, .heif, .webp, .avif',
  AUDIO_ACCEPT_TYPES = 'audio/mp3, audio/wav, audio/mpeg',
  ADD_IMAGE = 'Add an Image',
  IMAGE_LIMIT_MSG = 'Any JPG, JPEG, PNG, HEIC, HEIF, WEBP or GIF, AVIF, file size no more than 5MB',
  BACK = 'Back',
  EXPLORE_MORE = 'Explore More',
  DOWNLOADABLES_ID = 'downloadables_id',
  PAYMENT = 'Payment',
  US = 'US',
  INVALID_GIF_DIMENSION = 'INVALID_GIF_DIMENSION',
  IN = 'IN',
  Newsletter = "newsletter",
  Podcast = "podcast",
  Podcast_Titlecase = "Podcast",
  Article = "article",
  Newsletter_Titlecase = "Newsletter",
  Article_Titlecase = "Article",
  ACCOUNT_EXITS= 409,
  RESTRICTED = "RESTRICTED",
  FAN_EXISTS = 'FAN_EXISTS',
  CREATOR_EXISTS = 'CREATOR_EXISTS',
  FAN_EXISTS_MESSAGE = 'This email address already has a Fan account. To become a Creator, log in to your Fan account and go to Preferences > Create on TopFan',
  CREATOR_EXISTS_MESSAGE = 'This email address already has a Creator account.',
  FUNDRAISER = 'fundraiser',
  SEND_INVITE = 'send_invite',
  USER_SEGMENTATION = 'user_segmentation',
  EMAIL_TITLECASE = "Email",
  NEWLINE_PLACEHOLDER = '<!--NEWLINE_PRESERVE-->',
  PORTFOLIO = 'PORTFOLIO',
  PORTFOLIO_TITLECASE = 'Portfolio',
  PORTFOLIO_PURCHASE = 'Portfolio Purchase',
  PORTFOLIO_EARNING = 'Portfolio Earning',
  METADATA = 'metadata',
  Various = 'Various',
  PUBLISHED = 'published',
  DEFAULT_MARKETING_THEME_COLOR = '#00D2A6',
  THOUSAND = 1000,
  MY_GROUPS = 'My Groups'
}

export enum BucketFolders {
  bannerFolder = 'user_banner/',
  ProfileFolder = 'profile_image/',
  w9FormFolder = 'w9form_image',
  createPostVideoFolder = 'Posts/PostVideo/',
  createPostAudioFolder = 'Posts/PostAudio/',
  createPostPollFolder = 'Posts/PostPoll/',
  createPostImageFolder = 'Posts/PostsImage/',
  commentImages = 'commentImages',
  experienceImageFolder = 'experienceImages',
  nftImageFolder = 'nftImages',
  externalMerchFolder = 'externalMerchImages',
  coursesFolder = 'course_image/',
  portfolioContentFolder = 'portfolio/content/',
  messagesFolder = 'messages/',
  chatImagesFolder = 'chat/',
  messagesAudio = 'messages/audio',
  createMailingListFolder = 'mailingList/',
}

export enum DateText {
  YEAR = ' year ago',
  YEARS = ' years ago',
  DAY = ' day ago',
  DAYS = ' days ago',
  MONTH = ' month ago',
  MONTHS = ' months ago',
  HOUR = ' hour ago',
  HOURS = ' hours ago',
  MINUTE = ' minute ago',
  MINUTES = ' minutes ago',
  MonthDayYearFormat = 'MM-DD-YYYY',
  DATEFORMAT = 'MMM d, y',
  AD_EARNINGS_DATEFORMAT = 'YYYY-MM-DD',
}

export enum ValidationText {
  FromDateLessThanToDate = 'Filter By Date Range is Invalid.',
  EMAIL = 'Please Enter a Valid Email Address',
  NAME = 'Please Enter Name',
  COMMENT = 'Please Enter Comment'
}

export enum ThemeColor {
  default = '#013f5e',
  dark = '#424346',
  light = '#ecf2f5'
}

export enum SiteTitle {
  fullTitle = 'TopFan - The Best Platform for Creators',
  shortTitle = 'TopFan',
  site = 'Site'
}

export enum PauseResumeText {
  PAUSETEXT = 'Your account is Paused.',
  RESUMETEXT = 'Do you want to reactivate your Account?'
}

export enum CountryList {
  UNITED_STATES = 'United States'
}

export enum DefaultMimeTypes {
  IMAGE = 'image/jpeg',
  VIDEO = 'video/mp4',
  AUDIO = 'audio/mpeg'
}
